import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Documentos } from '../models/documentos';

@Injectable({
  providedIn: 'root'
})
export class UploadDocumentosService extends BaseService {

  constructor(
              private http: HttpClient
  ) {
    super();
  }

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  }

  handleError(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Código do erro: ${error.status}, ` + `menssagem: ${error.message}`;
    }
    return throwError(errorMessage);
  };

  getDocuments(tipoCotista: string, indIsentoIR1: string, indDesempregado: string): Observable<Documentos[]>{
    return this.http.get<Documentos[]>(this.UrlService + 'Inscricao/ObterDocumentoCotista/' + tipoCotista + '/' + indIsentoIR1 + '/' + indDesempregado)
    .pipe( catchError(this.handleError));
  }


}
